import globalUnits from "../units/globalUnits";
import { i18n } from "../i18/i18tn";

export function bindI18Events() {
  i18n.on("languageChanged", (lng) => {
    globalUnits.language = lng;
  });
}
